module.exports = {
    LatLng: woosmap.map.LatLng,
    LatLngBounds: woosmap.map.LatLngBounds,
    Point: woosmap.map.Point,
    Size: woosmap.map.Size,
};
